import classnames from 'classnames';
import React, { PureComponent } from 'react';
import { getTabItems } from '../utils';
import Package from './Package';

import { DEFAULT_PACKAGES } from '../../constants/main';

export default class PackagesTabSelection extends PureComponent {
    render() {
        const {
            packages,
            selectedPackage,
            pricingProps,
            primaryCTA,
            CTAStyle,
            smallScreen,
            selected,
            price,
            onClick,
            onLearnMore,
            tabClick,
            selectedIndex,
            extraTaxLabel,
        } = this.props;

        if (!packages) {
            return null;
        }

        const tabClasses = classnames({
            'eds-show-down-mn eds-g-offset-md-1-12 eds-g-cell-md-10-12':
                smallScreen,
        });

        const tabs = getTabItems(selectedIndex, DEFAULT_PACKAGES, tabClick);

        return (
            <div className={tabClasses}>
                <div className="eds-align--center">{tabs}</div>
                <Package
                    {...pricingProps}
                    {...packages[selectedPackage]}
                    primaryCTA={primaryCTA}
                    CTAStyle={CTAStyle}
                    smallScreen={smallScreen}
                    selected={selected}
                    price={price}
                    taxLabel={extraTaxLabel}
                    onClick={onClick}
                    onLearnMore={onLearnMore}
                />
            </div>
        );
    }
}
